import { Pagination, QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class LeanRest {
  private baseURL: string = "/lean";

  getResults(params?: QueryParams): Observable<Pagination<any>> {
    const url: string = `/results-get`;
    return api.get(url, params, this.baseURL);
  }
  updateStatus(data: any): Observable<any> {
    const url: string = `/results-update`;
    return api.put(url, data, {}, this.baseURL);
  }
  leanStats(params: QueryParams): Observable<any> {
    const url: string = `/engagment`;
    return api.get(url, params, this.baseURL);
  }
}
